import axios from 'axios';

export const apiDeleteFile = (id) => axios.delete(`/api/media/${id}`);
